import { DefaultMessages, ProgramThemeMessages, SegmentSpecificMessages } from '@sheerid/jslib';
import { RecursivePartial } from '../types/types';


type LibraryMessages = DefaultMessages & SegmentSpecificMessages & ProgramThemeMessages;


type ThisProjectMessages = {
    jobTitle: string
    optIn: string,
    ruleOptIn: string,
    collectInfoStepFooter: string,
    errorId: {
        invalidJobTitle: string,
    },
    step: {
        personalInfo: {
            countrySubLabel: string,
        },
    },
};


export const messagesEN: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    jobTitle: 'Job title',
    schoolName: 'Institution name',
    optIn: 'I would like to receive emails from GitLab about its product, services, and events.',
    ruleOptIn: 'Please check this box to verify that you will not use this license to run, administer, or operate an institution. If you wish to purchase a license for administrative uses, <a href="https://about.gitlab.com/company/contact/" class="sid-link" target="_blank" rel="noopener noreferrer">please contact us</a>.',
    infoShared1: '<span class="footer-other">By submitting the information on this form, you understand your information will be used for verification purposes.<br><br>The verification service is provided by SheerID on GitLab\'s behalf, and the information you provide will be shared with GitLab. For more information please see the <a href="https://about.gitlab.com/privacy/" class="sid-link" target="_blank" rel="noopener noreferrer">GitLab\'s Privacy Policy</a>. All use of GitLab products must comply with United States export control and economic sanction laws.<br><br></span></spam><span class="footer-collect-info">By submitting the information on this form, you understand your information will be used for verification purposes.<br><br>The verification service is provided by SheerID on GitLab\'s behalf and the information will be shared with GitLab. For more information please see the <a href="https://about.gitlab.com/privacy/" class="sid-link" target="_blank" rel="noopener noreferrer">GitLab\'s Privacy Policy</a><br><br>If you are accepted into the GitLab for Education Program, you will be subject to to the <a href="https://about.gitlab.com/handbook/legal/education-agreement/" class="sid-link" target="_blank" rel="noopener noreferrer">GitLab for Education Program Agreement</a>. All use of GitLab\'s products must comply with United States export control and economic sanction laws.<br><br></span>',
    infoShared2: ' ',
    informationTransferredToUS: 'Your information will be transferred to the United States and will be treated according to SheerID’s privacy policy.<br><br>',
    countryPlaceholder: 'Select...',
    verifyMyTeacherStatus: 'Submit',
    poweredBy: 'Verification services powered by SheerID.',
    errorId: {
        invalidJobTitle: 'Invalid job title',
    },
    step: {
        personalInfo: {
            title: 'Apply for the GitLab for Education Program',
            subtitle: 'Features of GitLab Ultimate, including 50,000 CI/CD minutes, are free for qualifying educational institutions. New and renewing members should use this form to verify eligibility.',
            countrySubLabel: 'If your country does not appear in this list, please email education@gitlab.com with your request.',
            howDoesVerifyingWorkDetails: 'To be eligible for this offer, you must currently be employed as a teacher, faculty or staff at a K-12 school in the United States.<br><br>Gitlab uses SheerID, a trusted partner, to verify that you are a current teacher, faculty or staff member. SheerID only collects information that assists in verifying your eligibility. Additional information or documentation may be requested.',
        },
        success: {
            title: 'Success!<br>You\'ve been verified',
            emailNotification: 'We have emailed you a personal coupon code and directions to obtain your subscription. It is unique to you and can only be used once.<br><br>Look for the email from verify@sheerid.com.',
        },
        pending: {
            turnaroundTime: 'SheerID is reviewing your documents, to confirm your status. This process typically takes only {estReviewTime}, and in rare times of high volume may take up to {maxReviewTime}.',
        },
        sso: {
            title: 'Verify using your<br>school credentials',
        },
        docUpload: {
            submitButtonLabel: 'Submit',
            uploadInstructions: 'Upload your school-issued document that shows:',
        },
    },
};
